import type { DecisionEngineDestinationUI } from "./definition";

export const marketoUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "smart campaign",
  channelDescription: "Marketo",
  // Marketo My Token names forbid periods, so collapse the dotted path to a
  // dot-free name. Must match the backend token name (lib .../marketo.ts).
  getReferenceString: (s) =>
    `{{my.ht_rec_var_${s.replace(/^hightouch\.recommendation\.variables\./, "")}}}`,
  isInactive: (resource) => resource?.status === "inactive",
  isPreviewSupported: true,
  getTemplateResourceType: () => "smart-campaign",
  getResourceType: () => "smart-campaign",
  // Marketo doesn't expose which email a smart campaign's flow sends, so the
  // marketer associates the email asset manually. It becomes the content
  // source for auto-tagging, embeddings, and content analysis.
  getContentResourceType: ({ type }) =>
    type === "email" ? "email-template" : null,
  contentResourceName: "email asset",
  getEmailPreviewMethod: "e2e",
  supportsRenderPreview: true,
  isTestSendSupported: true,
};
